import { render, staticRenderFns } from "./ExceptionApprovalModal.vue?vue&type=template&id=d05cf2a2&scoped=true"
import script from "./ExceptionApprovalModal.vue?vue&type=script&lang=js"
export * from "./ExceptionApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./ExceptionApprovalModal.vue?vue&type=style&index=0&id=d05cf2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05cf2a2",
  null
  
)

export default component.exports